import { SelectionPanel } from '$tablet-app/src/app/components/SelectionPanel';
import styled from 'styled-components/native';
import { useMealPreferenceDialogState } from '../../store/useMealPreferenceDialogState';

export const EatMeatView = () => {
  const eats_meat = useMealPreferenceDialogState(
    (state) => state.draft_preferences.eats_meat
  );

  const update = useMealPreferenceDialogState(
    (state) => state.updatePreference
  );

  const onChange = (eats_meat: boolean) => update({ eats_meat });

  return (
    <Container>
      <SelectionPanel
        icon="ban"
        iconColor="#FF7B43"
        backgroundColor="#FFEBE3"
        title="No meat"
        value={false}
        selected={eats_meat === false}
        onPress={onChange}
      />
      <SelectionPanel
        icon="check"
        iconColor="#059669"
        backgroundColor="rgba(3, 96, 67, 0.15)"
        title="Yes"
        value={true}
        selected={eats_meat === true}
        onPress={onChange}
      />
    </Container>
  );
};

const Container = styled.View`
  padding: 25px;

  flex-direction: row;
  justify-content: center;
  gap: 25px;
`;
